import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import i18n from './i18n'
import { useTranslation } from 'react-i18next'

const LanguageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  
  React.useEffect(() => {
    const path = location.pathname;
    const lang = path.split('/')[1];
    
    if (lang && ['en', 'sk', 'cz'].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [location, i18n]);

  return <>{children}</>;
};

const supportedLangs = ['en', 'sk', 'cz'];
const initialPathLang = window.location.pathname.split('/')[1];
const initialLang = supportedLangs.includes(initialPathLang) ? initialPathLang : 'cz';
i18n.changeLanguage(initialLang);

const rootElement = document.getElementById('root');
if (rootElement) {
  const app = (
    <React.StrictMode>
      <BrowserRouter>
        <LanguageWrapper>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/:lang" element={<App />} />
          </Routes>
        </LanguageWrapper>
      </BrowserRouter>
    </React.StrictMode>
  );

  if (rootElement.innerHTML.trim().length > 0) {
    hydrateRoot(rootElement, app);
  } else {
    createRoot(rootElement).render(app);
  }
}
